<template>
  <div class="bottom-icon">
    <img-v3 :src="formItem.icon_url" alt="" />
    <div class="bottom-text">{{ formItem.title }}</div>
  </div>
</template>
<script>
export default {
  props: ["formItem"],
  mounted() {},
  computed: {
    urlList() {
      return this.formItem.list || [];
    },
  },
};
</script>
<style lang="scss" scoped>
.bottom-icon {
  padding: 0.5rem 0;
  // margin-bottom: 2.6rem;
  display: flex;
  align-items: center;
  justify-content: center;
  > img {
    // width: 0.75rem;
    height: 0.75rem;
    margin-right: 0.16rem;
  }
  .bottom-text {
    max-width: 80%;
  }
}
</style>


